module.exports = __webpack_public_path__ + "img/maze_hexagonal_c.9c2eabae.svg";